import { render } from "./Top.vue?vue&type=template&id=13fa6b50&scoped=true&ts=true"
import script from "./Top.vue?vue&type=script&lang=ts"
export * from "./Top.vue?vue&type=script&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=13fa6b50&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fa6b50"]])

export default __exports__